<template>
  <section class='content'>
    <div class="row">
      <div :class="[loadingStores || showStores ? 'col-xs-6' : 'col-xs-12']">
        <multiselect v-model="company" :options="companies" placeholder="" label="name" track-by="id" @input="updateCompany" :allow-empty="false"></multiselect>
      </div>
      <div class="col-xs-6" v-if="loadingStores">
        <span><i class="fa fa-spinner fa-spin mr-5"></i>{{'loading_stores' | translate}}</span>
      </div>
      <div class="col-xs-6" v-else-if="showStores">
        <multiselect v-model="store" :options="getStoresOptions" placeholder="" label="name" track-by="id" @input="updateStore" :allow-empty="false">
          <template slot="option" slot-scope="props">
            <template v-if="props.option.id !== 0">
              <div class="option__desc">
              <span class="option__title">
                {{props.option.name}}, {{props.option.street}} {{props.option.street_no}}, {{props.option.zip_code}} {{props.option.city}}
              </span>
                <br/>
                <span class="small text-muted">{{'store_number' | translate}}: {{props.option.store_number}}</span>
              </div>
            </template>
            <div v-else class="option__desc">
               <span class="option__title">
                  {{props.option.name}}
               </span>
            </div>
          </template>
        </multiselect>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-3 col-sm-6">
        <div class="input-group">
          <div class="input-group-addon">
            {{'date' | translate}}:
          </div>
            <date-range-picker :startDate="dashboardStartRange" :endDate="dashboardEndRange" id="ordertime" @pepe="onDateRangeChanged"></date-range-picker>
        </div>
      </div>
      <div class="col-xs-9">
        <div class="col-sm-12 col-xs-12 text-right">
          <ul class="pagination pagination-sm no-margin" lang="de">
            <li class="paginate_button"><button @click="setDate('today')" :class="['paginate_button page-link', activeDateFilter === 'today' ? 'active' : '']">{{'today' | translate | capitalize}}</button></li>
            <li class="paginate_button"><button @click="setDate('yesterday')" :class="['paginate_button page-link', activeDateFilter === 'yesterday' ? 'active' : '']">{{'yesterday' | translate | capitalize}}</button></li>
            <li class="paginate_button"><button @click="setDate('thisMonth')" :class="['paginate_button page-link', activeDateFilter === 'thisMonth' ? 'active' : '']">{{'this_month' | translate}}</button></li>
            <li class="paginate_button"><button @click="setDate('lastMonth')" :class="['paginate_button page-link', activeDateFilter === 'lastMonth' ? 'active' : '']">{{'last_month' | translate}}</button></li>
            <li class="paginate_button"><button @click="setDate('thisYear')" :class="['paginate_button page-link', activeDateFilter === 'thisYear' ? 'active' : '']">{{'this_year' | translate}}</button></li>
            <li class="paginate_button"><button @click="setDate('lastYearSameTime')" :class="['paginate_button page-link', activeDateFilter === 'lastYearSameTime' ? 'active' : '']">{{'last_year_same_time' | translate}}</button></li>
            <li class="paginate_button"><button @click="setDate('lastYear')" :class="['paginate_button page-link', activeDateFilter === 'lastYear' ? 'active' : '']">{{'last_year' | translate}}</button></li>
            <li class="paginate_button"><button @click="setDate('total')" :class="['paginate_button page-link', activeDateFilter === 'total' ? 'active' : '']">{{'gesamt' | translate}}</button></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row pt-10">
      <order-boxes :title="'orders'" type="secondary" icon="fa-shopping-bag" :items="performance.orders"></order-boxes>
      <performance-box bootstrapClass="col-lg-3 col-md-6" :title="'cancellations'" type="danger" icon="fa-ban" :items="performance.cancellations"></performance-box>
      <performance-box bootstrapClass="col-lg-3 col-md-6" :title="'returns'" type="warning" icon="fa-retweet" :items="performance.returns"></performance-box>
      <performance-box bootstrapClass="col-lg-3 col-md-6" :title="'ranking'" :type="performance.ranking.status" icon="fa-star" :items="performance.ranking"></performance-box>
    </div>
    <div class="row">
      <div class="col-lg-9 col-md-12">
        <price-box :price="performance.orders" :priceMargin="priceMargin" :class="[positiveMargin !== true ? 'hide' : 'show']"></price-box>
        <price-box-mp :channelData="performance.orders.channels"></price-box-mp>
        <stats-report :orders="performance.orders"></stats-report>
      </div>
      <div class="col-lg-3 col-md-12">
        <div class="row">
          <payment-box bootstrapClass="col-lg-12 col-md-6" :title="'payment_companies'" icon="fa-home" :items="paymentByCompany" :loading="paymentByCompany.length === 0"></payment-box>
        </div>
        <div class="row">
          <payment-box bootstrapClass="col-lg-12 col-md-6" :title="'payment_stores'" icon="fa-home" :items="paymentStores" :loading="paymentStores.length === 0"></payment-box>
        </div>
        <div class="row">
          <click-and-collect-box bootstrapClass="col-lg-12 col-md-6" :title="'payment_stores'" icon="fa-dollar" type="info" :items="clickAndCollect"></click-and-collect-box>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-6">
            <div class="box box-primary box-solid">
              <div class="box-header no-border">
                <h3 class="box-title">{{'company_statistics' | translate}}</h3>
                <div class="box-tools pull-right" title="Details einblenden">
                  <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i></button>
                </div>
              </div>
              <div class="box-body">
                <div class="col-xs-12 mb-10">
                  <span>
                    {{'company_statistics_description' | translate}}<br />
                    <small class="text-muted">{{'company_statistics_description_small' | translate}}</small>
                  </span>
                </div>
                <div class="col-xs-12">
                  <a class="btn btn-success btn-sm" @click="downloadCompanyStatistics">
                    <i class="fa fa-cloud-download mr-5"></i>Download CSV
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <merchant-sales-report :merchantData="merchantData" :originalData="originalData"></merchant-sales-report>
    </div>
  </section>
</template>
<script>

import OrdersComponent from '../tools/OrderComponent.vue'
import OrderBoxesComponent from '../tools/OrderBoxesComponent.vue'
import MerchantBoxesComponent from '../tools/MerchantBoxesComponent.vue'
import OpenAndCollectComponent from '../tools/OpenAndCollectComponent.vue'
import ClickAndCollectBox from "../tools/ClickAndCollectBox";

export default {
  data () {
    return {
      activeDateFilter: window.localStorage.getItem('activeDateFilter')  ? window.localStorage.getItem('activeDateFilter') : 'today',
      dashboardSelectedStart: window.localStorage.getItem('dashboardSelectedStart') ? window.localStorage.getItem('dashboardSelectedStart') : moment().format('YYYY-MM-DD'),
      dashboardSelectedEnd: window.localStorage.getItem('dashboardSelectedEnd') ? window.localStorage.getItem('dashboardSelectedEnd') : moment().format('YYYY-MM-DD'),
      dashboardStartRange: window.localStorage.getItem('dashboardSelectedStart') ? moment(window.localStorage.getItem('dashboardSelectedStart')) : moment(),
      dashboardEndRange: window.localStorage.getItem('dashboardSelectedEnd') ? moment(window.localStorage.getItem('dashboardSelectedEnd')) : moment(),
      selectedCompany: 0,
      companies: [],
      paymentStores: [],
      paymentByCompany: [],
      clickAndCollect: [],
      priceMargin: 0,
      positiveMargin: false,
      priceArrangement: {},
      company: {
        id: 1,
        name: 'ANWR Media GmbH'
      },
      store: {
        id: 0,
        name: this.$options.filters.translate('all_stores', this.$store.getters.language)
      },
      last_import: '',
      current_month: moment(),
      performance: {
        cancellations: {},
        orders: {
          total: {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          month: {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          last_month: {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          '7_days': {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          '30_days': {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          yesterday: {
            items: '',
            amount: '',
            average: '',
            orders: ''
          },
          channels: {
            amazon: {
              yesterday: {
                items: '',
                amount: '',
                average: '',
                orders: ''
              },
                total: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                last_month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '7_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '30_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                }
              },
              ebay: {
                yesterday: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                total: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                last_month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '7_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '30_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                }
              },
              schuhede: {
                yesterday: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                total: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                last_month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '7_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '30_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                }
              },
              spartoo: {
                yesterday: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                total: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                last_month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '7_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '30_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                }
              },
              zalando: {
                yesterday: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                total: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                last_month: {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '7_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                },
                '30_days': {
                  items: '',
                  amount: '',
                  average: '',
                  orders: ''
                }
              }
          }
        },
        ranking: {
          points: '',
          position: '',
          rank: '',
          status: ''
        },
        returns: {}
      },
      ordersBack: {
        all: {
          items: 0,
          orders: 0,
          order_average: 0,
          total: 0,
          cancellations: {
            quantity: 0,
            percentage: 0
          },
          returns: {
            quantity: 0,
            percentage: 0
          }
        },
        today: {
          items: 0,
          orders: 0,
          order_average: 0,
          total: 0,
          cancellations: {
            quantity: 0,
            percentage: 0
          },
          returns: {
            quantity: 0,
            percentage: 0
          }
        },
        yesterday: {
          items: 0,
          orders: 0,
          order_average: 0,
          total: 0,
          cancellations: {
            quantity: 0,
            percentage: 0
          },
          returns: {
            quantity: 0,
            percentage: 0
          }
        },
        month: {
          items: 0,
          orders: 0,
          order_average: 0,
          total: 0,
          cancellations: {
            quantity: 0,
            percentage: 0
          },
          returns: {
            quantity: 0,
            percentage: 0
          }
        }
      },
      translate: this.$parent.translate,
      sales: {},
      response: {},
      todayData: {},
      merchantData: [{
          items: '',
        orders: ''
      }],
      stores: [],
      showStores: false,
      loadingStores: false,
      originalData: []
    }
  },
  components: {
    ClickAndCollectBox,
    latestOrders: OrdersComponent,
    orderBoxes: OrderBoxesComponent,
    merchantSalesReport: MerchantBoxesComponent,
    openCollect: OpenAndCollectComponent
  },
  methods: {
    downloadCompanyStatistics() {
      let dataString
      let headerString
      let downloadUrl = 'statistics/stores/details'
      if (this.company.id !== 1) {
        downloadUrl = `statistics/stores/details?company_id=${this.company.id}`
      }
      API.get(downloadUrl)
        .then(response => {
          let csvContent = 'data:text/csv;charset=utf-8,'
          response.data.forEach((infoArray, index) => {
            dataString = Object.keys(infoArray).map(k => {
              if (k === 'price' || k === 'fee' || k === 'additional_fee') {
                return infoArray[k] === null ? ' ' : '"' + infoArray[k].toString().replace('.', ',') + '"'
              } else {
                return infoArray[k] === null ? ' ' : '"' + infoArray[k] + '"'
              }
            }).join(',')
            if (index === 0) {
              headerString = Object.keys(infoArray).map(k => {
                return k
              }).join(',')
              csvContent += headerString + '\n'
            }
            csvContent += index < response.data.length ? dataString + '\n' : dataString
          })
          let encodedUri = encodeURI(csvContent)
          let link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', 'company_statistics_' + this.company.id + '.csv')
          document.body.appendChild(link)
          link.click()
          this.loading = false
        })
    },
    setDate (dateString) {
      switch (dateString) {
        case 'today':
          this.dashboardSelectedStart = moment().format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().format('YYYY-MM-DD')
          break
        case 'yesterday':
          this.dashboardSelectedStart = moment().subtract(1, 'day').format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().subtract(1, 'day').format('YYYY-MM-DD')
          break
        case 'thisMonth':
          let dateThisMonth = this.prepareDate()
          this.dashboardSelectedStart = moment(dateThisMonth.year + "-" + dateThisMonth.month + "-01").format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().format('YYYY-MM-DD')
          break
        case 'lastMonth':
          let lastMonth = moment().subtract(1, 'month')
          let lastMonthData = {"day": lastMonth.format('DD'), "month": lastMonth.format('MM'), "year": lastMonth.format('YYYY')}
          let monthMaxDays = new Date(lastMonthData.year, lastMonthData.month, 0).getDate()
          this.dashboardSelectedStart = moment(lastMonthData.year + "-" + lastMonthData.month + "-01").format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment(lastMonthData.year + "-" + lastMonthData.month + "-" + monthMaxDays).format('YYYY-MM-DD')
          break
        case 'lastYearSameTime':
          let lastYear = moment().subtract(1, 'year')
          let lastYearData = {"day": lastYear.format('DD'), "month": lastYear.format('MM'), "year": lastYear.format('YYYY')}
          this.dashboardSelectedStart = moment(lastYearData.year + "-01-01").format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment(lastYearData.year + "-" + moment().format('MM') + '-' + moment().format('DD')).format('YYYY-MM-DD')
          break
        case 'lastYear':
          let data = {"day": moment().subtract(1, 'year').format('DD'), "month": moment().subtract(1, 'year').format('MM'), "year": moment().subtract(1, 'year').format('YYYY')}
          this.dashboardSelectedStart = moment(data.year + "-01-01").format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment(data.year + "-12-31").format('YYYY-MM-DD')
          break
        case 'thisYear':
          let currentYear  = this.prepareDate()
          this.dashboardSelectedStart = moment(currentYear.year + "-01-01").format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().format('YYYY-MM-DD')
          break
        case 'total':
          this.dashboardSelectedStart = moment("2017-01-01T00:00:00").format('YYYY-MM-DD')
          this.dashboardSelectedEnd = moment().format('YYYY-MM-DD')
          break
      }
      this.activeDateFilter = dateString
      this.updateData()
    },
    prepareDate () {
      return {"day": moment().format('DD'), "month": moment().format('MM'), "year": moment().format('YYYY')}
    },
    onDateRangeChanged (picker) {
      this.dashboardStartRange = picker.startDate
      this.dashboardEndRange = picker.endDate
      this.dashboardSelectedStart = this.dashboardStartRange.format('YYYY-MM-DD')
      this.dashboardSelectedEnd = this.dashboardEndRange.format('YYYY-MM-DD')
      this.activeDateFilter = ''
      window.localStorage.setItem('activeDateFilter', this.activeDateFilter)
      this.updateData()
    },
    calculateTime () {
      let time = Math.ceil(moment().diff(moment().startOf('hour'), 'minutes') / 5)
      time++
      time = time + ((time - 1) * 4)
      let callback = moment().minutes(time).seconds(0)
      return (callback.diff(moment().seconds(0), 'miliseconds'))
    },
    updateData () {
      this.orders = this.ordersBack
      window.localStorage.setItem('dashboardSelectedStart', this.dashboardSelectedStart)
      window.localStorage.setItem('dashboardSelectedEnd', this.dashboardSelectedEnd)
      window.localStorage.setItem('activeDateFilter', this.activeDateFilter)
      API.get(`statistics/performance/${this.company.id}`, {"params": {"start": this.dashboardSelectedStart, "end": this.dashboardSelectedEnd}})
        .then(response => {
          this.performance = response.data
          this.calculatePriceMargin()
        })
      API.get('statistics/live/sales', {})
        .then(response => {
          this.merchantData = response.data.data
          this.originalData = response.data.data
          setTimeout(this.updateData, this.calculateTime())
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateCompany (e) {
      this.loadingStores = true
      this.selectedCompany = this.merchantData.findIndex(x => x.id === e.id)
      this.showStores = false
    	API.get(`statistics/performance/${e.id}`, {"params": {"start": this.dashboardSelectedStart, "end": this.dashboardSelectedEnd}})
        .then(response => {
	        this.performance = response.data
          this.getStores()
          this.calculatePriceMargin()
        })
    },
    getStores () {
      this.store = {
        id: 0,
        name: this.$options.filters.translate('all_stores', this.$store.getters.language)}
      API.get(`accounting/companies/${this.company.id}/stores`)
        .then(response => {
          this.stores = response.data
          this.loadingStores = false
          this.showStores = true
        })
    },
    updateStore (e) {
      API.get(`statistics/performance/${this.company.id}?start=${this.dashboardSelectedStart}&end=${this.dashboardSelectedEnd}${this.store.id !== 0 ? `&store_id=${e.id}` : ''}`)
        .then(response => {
          this.performance = response.data
          this.calculatePriceMargin()
        })
    },
    calculatePriceMargin () {
      this.priceMargin = this.performance.orders.amount_diff / (this.performance.orders.expected_amount/100)
      this.priceMargin > -1000 ? this.positiveMargin = true : this.positiveMargin = false
    }
  },
  mounted () {
    this.$nextTick(() => {
	    this.companies = this.$store.getters.companies
      API.get('statistics/clickAndCollect')
        .then(res => {
          this.clickAndCollect = res.data
        })
        .catch(error => {
          console.log(error)
        })
      API.get('statistics/byCompany')
        .then(res => {
          this.paymentByCompany = res.data
        })
        .catch(error => {
          console.log(error)
        })
      API.get('statistics/stores')
        .then(res => {
          this.paymentStores = res.data
        })
        .catch(error => {
          console.log(error)
        })
	    API.get('statistics/performance/1', {"params": {"start": this.dashboardSelectedStart, "end": this.dashboardSelectedEnd}})
		    .then(res => {
			    this.performance = res.data
          this.calculatePriceMargin()
		    })
		    .catch(error => {
			    console.log(error)
		    })
      API.get('statistics/live/sales', {})
        .then(response => {
          this.merchantData = response.data.data.sort((a, b) => {
            return a.orders - b.orders
          }).reverse()
          this.originalData = response.data.data
          this.todayData = this.merchantData[0]
          setTimeout(this.updateData, this.calculateTime())
        })
        .catch(error => {
          console.log(error)
        })
      window.localStorage.setItem('orderPage', 1)
      window.localStorage.setItem('orderStatus', 'all')
      window.localStorage.setItem('companiesPage', 1)
      window.localStorage.setItem('companiesStatus', 'all')
      window.localStorage.setItem('orderChannel', 0)
      window.localStorage.setItem('orderSku', '')
      window.localStorage.setItem('orderMerchant', '')
      window.localStorage.setItem('sortType', 'desc')
      window.localStorage.setItem('dashboardSelectedStart', this.dashboardSelectedStart)
      window.localStorage.setItem('dashboardSelectedEnd', this.dashboardSelectedEnd)
      window.localStorage.setItem('activeDateFilter', this.activeDateFilter)
    })
  },
  computed: {
    getStoresOptions () {
      return [{id: 0, name: this.$options.filters.translate('all_stores', this.$store.getters.language)}].concat(this.stores)
    }
  },
  watch: {
  	merchantData () {},
    performance () {},
    selectedCompany () {
  	  let obj = {
  	    amount: 0,
        average: 0,
        company: '',
        id: this.selectedCompany,
        items: 0,
        orders: 0
  	  }
  	  this.todayData = typeof this.merchantData[this.selectedCompany] === 'undefined' ? obj : this.merchantData[this.selectedCompany]
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px !important;
    background: transparent !important;
    color: #ffffff !important;
    z-index: 10;
  }
  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0px !important;
    border: 1px solid rgba(255,255,255,.15);
    color: #ffffff;
    background: transparent !important;
    font-size: 14px;
  }
  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #212228;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid rgba(255,255,255,.15);
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
  }

</style>




// WEBPACK FOOTER //
// src/components/views/Dashboard.vue